import { useTranslation } from "react-i18next";

import { Flex } from "components";
import { useAuth } from "hooks";
import { CircledQuestion } from "icons";
import { makeBEM, cssColor } from "utils";

import "./index.scss";

const bem = makeBEM("help-email");

export const HelpEmail = () => {
  const { t } = useTranslation("common");
  const { user } = useAuth();

  const emailSubject = `MeApp API: ${user?.email}`;

  return (
    <Flex className={bem()} align="top" gap="1rem">
      <CircledQuestion color={cssColor("gray-600")} />
      <div>
        <div className={bem("label")}>{t("have_questions")}</div>
        <div>
          <a
            className={bem("link")}
            href={`${t("help_email_link")}?subject=${emailSubject}`}
            target="_blank"
            rel="noreferrer"
          >
            {t("help_email")}
          </a>
        </div>
      </div>
    </Flex>
  );
};
